{{ teamNameTruncated() }}
